<template>
    <v-col>
        <v-row dense>
            <v-col cols="12" md="4"><v-btn @click="$emit('listenbutonkey','7')"><span class="text-h5">7</span></v-btn></v-col>
            <v-col cols="12" md="4"><v-btn @click="$emit('listenbutonkey','8')"><span class="text-h5">8</span></v-btn></v-col>
            <v-col cols="12" md="4"><v-btn @click="$emit('listenbutonkey','9')"><span class="text-h5">9</span></v-btn></v-col>
        </v-row>
        <v-row dense>
            <v-col cols="12" md="4"><v-btn @click="$emit('listenbutonkey','4')"><span class="text-h5">4</span></v-btn></v-col>
            <v-col cols="12" md="4"><v-btn @click="$emit('listenbutonkey','5')"><span class="text-h5">5</span></v-btn></v-col>
            <v-col cols="12" md="4"><v-btn @click="$emit('listenbutonkey','6')"><span class="text-h5">6</span></v-btn></v-col>
        </v-row>
        <v-row dense>
            <v-col cols="12" md="4"><v-btn @click="$emit('listenbutonkey','1')"><span class="text-h5">1</span></v-btn></v-col>
            <v-col cols="12" md="4"><v-btn @click="$emit('listenbutonkey','2')"><span class="text-h5">2</span></v-btn></v-col>
            <v-col cols="12" md="4"><v-btn @click="$emit('listenbutonkey','3')"><span class="text-h5">3</span></v-btn></v-col>
        </v-row>
        <v-row dense>
            <v-col cols="12" md="4"><v-btn @click="$emit('listenbutonkey','0')"><span class="text-h5">0</span></v-btn></v-col>
            <v-col cols="12" md="6">
                <v-btn @click="$emit('listenbutonkey','*')" block>
                    <v-icon size="large">mdi-backspace</v-icon>
                </v-btn>
            </v-col>
        </v-row>
    </v-col>
</template>